import { draft } from '../../resources/draft';
import { deleteDraftSuccess, deleteDraftError } from '../draft/actions';

import { DELETE_DRAFT } from '../constants';

const deleteDraftMiddleware = ({ dispatch }) => next => action => {
  const { type } = action;

  if (type !== DELETE_DRAFT) {
    return next(action);
  }

  if (draft) {
    draft
      .deleteAuto()
      .then(() => dispatch(deleteDraftSuccess()))
      .catch(() => dispatch(deleteDraftError()));
  }

  return next(action);
};

export default deleteDraftMiddleware;
